<template>
  <div class="edrea_tm_section" id="contact">
    <div class="section_inner">
      <div class="edrea_tm_contact">
        <div class="edrea_tm_main_title">
          <h3>Get in <span class="coloring">Touch</span></h3>
        </div>
        <div class="wrapper">
          <div class="left">
            <ul>
              <li>
                <div class="list_inner">
                  <i class="icon-location"></i>
                  <span
                    ><a
  class="href_location"
  href="https://www.google.com/maps/search/?api=1&query=Adelaide%20CBD%20SA%205000%2C%20Australia"
  target="_blank"
  rel="noopener"
>
  Adelaide CBD SA 5000, Australia
</a>
</span
                  >
                </div>
              </li>
              <li>
  <div class="list_inner">
    <i class="icon-phone"></i> <span>
      <a href="tel:+61416261864">+61 416 261 864</a>
    </span>
  </div>
</li>
              <li>
                <div class="list_inner">
                  <i class="icon-mail-1"></i>
                  <span
                    ><a href="oztechcreative@gmail.com"
                      >oztechcreative@gmail.com</a
                    ></span
                  >
                </div>
              </li>
             <li>
  <div class="list_inner">
    <i class="fa-brands fa-instagram" style="color: #e41672; margin-left: 5px;"></i> 
    <span>
      <a href="https://instagram.com/oztechcreative" target="_blank">@oztechcreative</a>
    </span>
  </div>
</li>
            </ul>
          </div>
          <div class="right">
            <div class="fields">
              <form
                @submit.prevent="submitForm"
                class="contact_form"
                id="contact_form"
              >
              <div
  class="returnmessage"
  data-success="Your message has been received, We will contact you soon."
  v-if="isSubmitted" >
  Your message has been received, We will contact you soon. 
</div>
<div class="empty_notice">
  <span>Please Fill Required Fields</span>
</div>
                <div class="first">
  <ul>
    <li>
      <div class="list_inner">
        <input id="name" type="text" name="name" placeholder="Name" autocomplete="off" required />
      </div>
    </li>
    <li>
      <div class="list_inner">
        <input id="phone" type="tel" name="phone" placeholder="Phone Number" autocomplete="off" />
      </div>
    </li>
  </ul>
</div>

<div class="email_section">
  <div class="list_inner">
    <input id="email" type="email" name="email" placeholder="Email" autocomplete="off" required />
  </div>
</div>

<div class="message_section">
  <div class="list_inner">
    <textarea id="message" name="message" placeholder="Message" required></textarea>
  </div>
</div>

    <!--   EMAIL FIELD
    <li style="margin-bottom: 20px; list-style: none;">
      <div class="list_inner">
        <input id="email" type="email" name="email" placeholder="Email" autocomplete="off" required />
      </div>
    </li>

  </ul>
  <textarea id="message" name="message" placeholder="Message" required></textarea>
</div>    -->
                                <div class="edrea_tm_button">
                  <button id="send_message" type="submit">Send Message</button> </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// ContactComponent.vue <script>
export default {
    name: `ContactComponent`,
    data() {
        return {
            // New state variable to control success message visibility
            isSubmitted: false, 
            // Replace with your actual Formspree endpoint!
            formUrl: 'https://formspree.io/f/xdaopayr', 
        };
    },
    methods: {
        async submitForm(event) {
            const form = event.target;
            const data = new FormData(form);

            try {
                const response = await fetch(this.formUrl, {
                    method: 'POST',
                    body: data,
                    headers: {
                        'Accept': 'application/json' // Tells Formspree we want a JSON response
                    }
                });

                if (response.ok) {
                    // Success!
                    this.isSubmitted = true; // Show the success message
                    form.reset(); // Clear the form fields

                    // Optional: Hide the success message after a few seconds
                    setTimeout(() => {
                        this.isSubmitted = false;
                    }, 5000);

                } else {
                    // Submission failed (e.g., rate limit, incorrect field)
                    alert('There was an issue sending your message. Please try again.');
                }
            } catch (error) {
                console.error('Submission error:', error);
                alert('An error occurred. Please check your network connection.');
            }
        }
    }
};
</script>

<style scoped>

/* ── BUTTON ────────────────────────────────────────────── */
.edrea_tm_button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.edrea_tm_button #send_message {
    padding: 12px 55px;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    background-color: transparent;
    border: 2px solid #e41672;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
}

.edrea_tm_button #send_message:hover {
    background-color: #e41672;
    color: #000;
}

/* ── FORM LAYOUT ───────────────────────────────────────── */
.fields {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* ── NAME & PHONE ROW ──────────────────────────────────── */
.first ul {
    display: flex;
    gap: 15px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.first ul li {
    flex: 1;
}
.first ul li input {
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
/* ── EMAIL & MESSAGE ───────────────────────────────────── */
.last ul {
    display: flex;
    flex-direction: column;
    gap: 15px;
    list-style: none;
    padding: 0;
    margin: 0;
}

/* ── ALL INPUTS & TEXTAREA ─────────────────────────────── */
.list_inner input,
.list_inner textarea {
    width: 100%;
    background-color: #1c1c1c;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    padding: 18px 20px;
    border-radius: 15px;
    outline: none;
    display: block;
    box-sizing: border-box;
    font-size: 14px;
    margin-bottom: 0;
  
}

.list_inner input:hover,
.list_inner textarea:hover {
    border-color: #e41672 !important;
}
.list_inner input::placeholder,
.list_inner textarea::placeholder {
    color: rgba(255, 255, 255, 0.35);
}

.list_inner input:focus,
.list_inner textarea:focus {
    border-color: #e41672 !important;
    border: 1px solid #e41672 !important;
}

/* ── MESSAGE BOX HEIGHT ────────────────────────────────── */
.list_inner textarea {
    min-height: 150px;
    resize: none;
}
.email_section {
    margin-bottom: 15px;
}

.message_section {
    margin-top: 15px;
}

/* ── SUCCESS MESSAGE ───────────────────────────────────── */
.returnmessage {
    color: #e41672;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
    display: block;
}

/* ── MOBILE ────────────────────────────────────────────── */
@media (max-width: 768px) {
    .first ul {
        flex-direction: column;
    }
}

</style>